//Check digit sum (see MPAN documentation online)
export const checkMpanDigitSum = (mpan: string | number) => {
  const primes = [3, 5, 7, 13, 17, 19, 23, 29, 31, 37, 41, 43];
  let sum = 0;
  const m = mpan?.toString();

  if (m && m.length - 1 === primes.length) {
    for (let i = 0; i < primes.length; i++) {
      sum += parseInt(m.charAt(i)) * primes[i];
    }
    return (sum % 11) % 10 === parseInt(m.charAt(12));
  }

  return false;
};

export const normalizeMpan = (value: string | undefined | null): string => {
  if (!value) return '';
  return value.replace(/\s+/g, '').replace(/\D/g, '');
};

export const makeMpanChecks =
  (isLocalHost: boolean) =>
  (value?: unknown): boolean => {
    const str = typeof value === 'string' ? value : String(value ?? '');

    if (isLocalHost) return true;
    if (!str) return false;
    if (str.length !== 13) return false;

    return checkMpanDigitSum(str);
  };

export const formatFieldLabel = (path: string) => {
  return path
    .replace(/\./g, ' ')
    .replace(/\[(\d+)\]/g, ' $1 ')
    .replace(/([A-Z])/g, ' $1')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()
    .replace(/^./, c => c.toUpperCase());
};
